<template>
    <div class="flex justify-center">
        <div v-for="i in 7"
             class=""
        ><button class="p-3 m-1 border-2 bg-blue-100 hover:bg-blue-200"
                 :class="{'font-bold': (i-1) == step}"
                 @click="step = (i-1)"
        >{{ i-1 }}</button></div>
    </div>

</template>

<script>
import {mapFields, updateField} from 'vuex-map-fields';

export default {
    computed: {
        ...mapFields(['step'])
    },
    methods: {
        setActiveStep(step) {
            // this.$store.commit('updateField', {
            //     path: 'step',
            //     value: 1
            // });
        }
    }
}
</script>
